import { render } from "./DisplayPane.vue?vue&type=template&id=0d7d15c2"
import script from "./DisplayPane.vue?vue&type=script&lang=js"
export * from "./DisplayPane.vue?vue&type=script&lang=js"

import "./DisplayPane.vue?vue&type=style&index=0&id=0d7d15c2&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__